import { Component, EventEmitter, Output } from '@angular/core';
import {
  getShortcodeBySelectValue,
  buildShortcodeInsertHtml,
} from '../utils/email-shortcode-token.util';

@Component({
  selector: 'app-shortcode-select',
  templateUrl: './shortcode-select.component.html',
  styleUrls: ['./shortcode-select.component.scss'],
})
export class ShortcodeSelectComponent {
  shortcodeSelected = 'add_shortcode';

  @Output() onShortCodeSelect = new EventEmitter();

  public onShortcodeChanged(ev: any): void {
    const selectValue: string = JSON.parse(JSON.stringify(this.shortcodeSelected));
    const def = getShortcodeBySelectValue(selectValue);

    if (!def) {
      // Unknown / default option — do nothing
      return;
    }

    // code: the raw shortcode or insert HTML (backward-compatible field)
    const code = def.insertHtml ?? def.shortcode;

    // content: legacy-wrapped version (kept for any caller that still reads it)
    const content = `<font face="arial, helvetica, sans-serif"><font size="2" style="font-size: 11pt">${code}</font></font>`;

    // insertHtml: the token-aware HTML callers should prefer
    const insertHtml = buildShortcodeInsertHtml(def);

    this.onShortCodeSelect.emit({
      shortcode: selectValue,        // e.g. "first_name"
      command: 'mceInsertContent',
      code,                          // raw shortcode / legacy insert
      content,                       // legacy font-wrapped content
      label: def.label,              // e.g. "First Name"
      insertHtml,                    // token-chip HTML — use this for insertion
      isLink: def.isLink ?? false,
    });

    setTimeout(() => {
      this.shortcodeSelected = 'add_shortcode';
    }, 500);
  }
}
